<template>
  <div>
    <v-tabs fixed-tabs background-color="indigo" dark v-model="tab">
      <v-tab>Resumen del Dia</v-tab>
      <v-tab>Ultimas Ventas</v-tab>
      <v-tab>Mercaderia en tránsito</v-tab>
      <v-tab v-if="esAdmin">Descuentos realizados</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-title
            >{{ $store.state.datos.sucursal.descripcion }}
            {{ Date.now() | moment("dddd D [de] MMMM YYYY") }}</v-card-title
          >
          <v-card-text>
            <v-alert type="warning" dense v-if="stockMinimo.length > 0">
              <v-row align="center">
                <v-col class="grow">
                  Hay {{ stockMinimo.length }} producto{{
                    stockMinimo.length > 1 ? "s" : ""
                  }}
                  con stock minimo.
                </v-col>
                <v-col class="shrink">
                  <v-btn
                    icon
                    @click="
                      expandirAlertaStockMinimo = !expandirAlertaStockMinimo
                    "
                    ><v-icon
                      >mdi-arrow-{{
                        expandirAlertaStockMinimo ? "up" : "down"
                      }}</v-icon
                    ></v-btn
                  >
                </v-col>
              </v-row>
              <v-expand-transition>
                <v-card
                  v-show="expandirAlertaStockMinimo"
                  class="mx-auto primary"
                >
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Producto
                          </th>
                          <th class="text-left">
                            Stock actual
                          </th>
                          <th class="text-left">
                            Minimo
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in stockMinimo" :key="item._id">
                          <td>{{ item.nombre }}</td>
                          <td>{{ item.stock }}</td>
                          <td>{{ item.stockMinimo }}</td>
                          <td>
                            <v-icon @click="irProducto(item._id)"
                              >mdi-eye</v-icon
                            >
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-expand-transition>
            </v-alert>
            <VueApexCharts
              type="line"
              height="300px"
              :options="grafico.opciones"
              :series="grafico.series"
            ></VueApexCharts>
            <v-row>
              <v-col cols="6"
                ><v-card class="mx-auto" color="grey lighten-4">
                  <v-card-title>
                    <v-icon color="green" class="mr-12" size="64">
                      mdi-format-list-numbered
                    </v-icon>
                    <v-row align="start">
                      <div class="caption grey--text text-uppercase">
                        Cantidad de Clientes
                      </div>
                      <div>
                        <span class="display-2 font-weight-black"></span>
                        <strong>{{ clientes }}</strong>
                      </div>
                    </v-row>
                  </v-card-title>
                </v-card></v-col
              >
              <v-col cols="6"
                ><v-card class="mx-auto" color="grey lighten-4">
                  <v-card-title>
                    <v-icon color="green" class="mr-12" size="64">
                      mdi-currency-usd
                    </v-icon>
                    <v-row align="start">
                      <div class="caption grey--text text-uppercase">
                        Monto total
                      </div>
                      <div>
                        <span class="display-2 font-weight-black"></span>
                        <strong>$ {{ total }}</strong>
                      </div>
                    </v-row>
                  </v-card-title>
                </v-card></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        ><v-data-table :headers="encabezados" :items="ventas" :search="search">
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th :colspan="headers.length">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Ingrese busqueda"
                    single-line
                    hide-details
                  ></v-text-field>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item.fechaAlta="{ item }">
            {{ item.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm") }}
          </template>
          <template v-slot:item.acciones="{ item }">
            <v-icon small class="mr-2" @click="verItem(item._id)"
              >mdi-eye</v-icon
            >
          </template>
        </v-data-table></v-tab-item
      >
      <v-tab-item>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Fecha y Hora de Pedido
                </th>
                <th class="text-left">
                  Proveedor
                </th>
                <th class="text-left">
                  Comprobante
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!enTransito.length">
                <td>No hay mercaderia en transito.</td>
              </tr>
              <tr v-for="(item, index) in enTransito" :key="index">
                <td>
                  {{
                    $moment(item.fechaAlta).format(
                      "dddd DD [de] MMMM YYYY H:mm"
                    )
                  }}
                </td>
                <td>{{ item.proveedor.nombre }}</td>
                <td>
                  {{ item.comprobanteCompra.tipo }}
                  {{ item.comprobanteCompra.numero }}
                </td>
                <td><v-icon @click="altaMercaderia(item)">mdi-eye</v-icon></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table :headers="encabezadosDescuentos" :items="descuentosRealizados" :search="searchDescuentos">
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th :colspan="headers.length">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Ingrese busqueda"
                    single-line
                    hide-details
                  ></v-text-field>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item.fechaAlta="{ item }">
            {{ item.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm") }}
          </template>
          <template v-slot:item.acciones="{ item }">
            <v-icon small class="mr-2" @click="verItem(item._id)"
              >mdi-eye</v-icon
            >
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
export default {
  name: "Home",
  data() {
    return {
      tab: 0,
      ventas: {},
      desde: this.$moment().format("YYYY-MM-DD"),
      hasta: this.$moment()
        .add(1, "days")
        .format("YYYY-MM-DD"),
      clientes: 0,
      total: 0,
      grafico: {
        opciones: {
          chart: {
            type: "area",
          },
          markers: {
            size: 0,
          },
          title: {
            text: "Ventas del dia",
            align: "left",
          },
          yaxis: {
            title: {
              text: "Monto",
            },
          },
        },
        series: [],
      },
      encabezados: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta",
        },
        { text: "Cliente", value: "cliente.nombre" },
        { text: "Tipo de Comprobante", value: "comprobante.tipo" },
        { text: "Subtotal", value: "subtotal" },
        { text: "Descuentos", value: "descuento" },
        { text: "Recargos", value: "recargo" },
        { text: "Total", value: "total" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      encabezadosDescuentos: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta",
        },
        { text: "Cliente", value: "cliente.nombre" },
        { text: "Subtotal", value: "total" },
        { text: "Descuento realizado", value: "descuento" },
        { text: "Total", value: "total" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      descuentosRealizados: [],
      searchDescuentos: "",
      search: "",
      listado: [],
      loading: true,
      stockMinimo: [],
      expandirAlertaStockMinimo: false,
      enTransito: [],
    };
  },
  components: {
    VueApexCharts,
  },
  async created() {
    try {
      const ventas = await axios.post("/ventas/", {
        desde: this.desde,
        hasta: this.hasta,
      });
      this.ventas = ventas.data;
      let data = [];
      let i = 0;
      let total = 0;
      ventas.data.forEach((element) => {
        data.push({
          x: this.$moment(element.fechaAlta).format("DD/MM/YYYY HH:mm"),
          y: element.total,
        });
        i++;
        total += element.total;
      });
      this.grafico.series.push({ name: "Monto", data: data.reverse() });
      this.clientes = i;
      this.total = total;
      const stockMinimo = await axios.get("/productos/stockMinimo");
      this.stockMinimo = stockMinimo.data;
      this.obtenerComprasEnTransito();
      if(this.esAdmin) this.obtenerDescuentosRealizados();
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async obtenerDescuentosRealizados() {
      try {
        const descuentos = await axios.get("/panel/descuentosRealizados");
        this.descuentosRealizados = descuentos.data
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerComprasEnTransito() {
      try {
        const compras = await axios.get("/compras/enTransito");
        this.enTransito = compras.data;
      } catch (error) {
        console.log(error);
      }
    },
    verItem(id) {
      this.$router.push(`/ventas/${id}`);
    },
    altaMercaderia(compra) {
      this.$router.push({
        name: "Mercaderias_Nuevo",
        params: {
          compra,
        },
      });
    },
    irProducto(id) {
      this.$router.push(`/productos/${id}`);
    },
  },
  computed: {
    esAdmin() {
      return this.$store.state.datos.roles.includes("superadmin");
    },
  },
};
</script>
